document.querySelectorAll('.js-filter-date-from').forEach((dateInputFrom) => {
  const filterItem = dateInputFrom.closest('.c-filter__item--input');
  const dateInputTo = filterItem.querySelector('.js-filter-date-to');
  const applyButton = filterItem.querySelector('.js-filter-apply-button');
  const resetButton = filterItem.querySelector('.js-filter-reset-button');

  const parseDate = (dateString) => {
    const [year, month, day] = dateString.split('-');
    const date = new Date(year, month - 1, day);

    if (date && (date.getMonth() === month - 1) && (date.getFullYear() === +year)) {
      return date;
    }

    return undefined;
  };

  const getApplyLink = () => {
    if (!dateInputFrom.validity.valid || !dateInputTo.validity.valid) {
      return '';
    }

    if (dateInputFrom.value === '') {
      if (dateInputTo.value === '') {
        return applyButton.dataset.href;
      }
      return '';
    }

    const fromDate = parseDate(dateInputFrom.value);
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());

    if (!(fromDate instanceof Date) || fromDate < today) {
      return '';
    }

    if (dateInputTo.value === '') {
      return applyButton.dataset.href.replace('#', dateInputFrom.value + '/#');
    }

    const toDate = parseDate(dateInputTo.value);

    if (!(toDate instanceof Date) || toDate < fromDate) {
      return '';
    }

    return applyButton.dataset.href.replace('#', dateInputFrom.value + '-' + dateInputTo.value + '/#');
  };

  const setButtons = () => {
    const href = getApplyLink();

    if (href === '') {
      delete applyButton.href;
      applyButton.setAttribute('aria-disabled', 'true');
    } else {
      applyButton.href = href;
      applyButton.removeAttribute('aria-disabled');
    }

    if (resetButton) {
      if (dateInputFrom.validity.valid && dateInputFrom.value === dateInputFrom.min && dateInputTo.validity.valid && dateInputTo.value === '') {
        resetButton.setAttribute('aria-disabled', 'true');
      } else {
        resetButton.removeAttribute('aria-disabled');
      }
    }
  };

  const setInputAttributes = () => {
    dateInputFrom.max = (dateInputTo.value === '') ? dateInputTo.max : dateInputTo.value;
    dateInputTo.min = (dateInputFrom.value === '') ? dateInputFrom.min : dateInputFrom.value;

    // Set HTML value attributes for CSS selector
    dateInputFrom.setAttribute('value', dateInputFrom.value);
    dateInputTo.setAttribute('value', dateInputTo.value);
  };

  if (resetButton) {
    resetButton.addEventListener('click', () => {
      dateInputFrom.value = dateInputFrom.min;
      dateInputTo.value = '';

      setInputAttributes();
      setButtons();
    });
  }

  dateInputFrom.addEventListener('input', setButtons);
  dateInputTo.addEventListener('input', setButtons);

  dateInputFrom.addEventListener('invalid', setButtons);
  dateInputTo.addEventListener('invalid', setButtons);

  dateInputFrom.addEventListener('blur', setButtons);
  dateInputTo.addEventListener('blur', setButtons);

  dateInputFrom.addEventListener('blur', setInputAttributes);
  dateInputTo.addEventListener('blur', setInputAttributes);
});
